import React, { useContext } from 'react';
import ContentLoader from 'react-content-loader';
import { ThemeContext } from 'styled-components';

const WidgetLoader = () => {
  const themeContext = useContext(ThemeContext);
  const random = Math.random() * (1 - 0.7) + 0.7;
  return (
    <ContentLoader
      speed={1}
      backgroundColor={themeContext?.loadingTableColor}
      foregroundColor={themeContext?.loadingTableColor}
      primaryopacity={1}
      secondaryopacity={0.6}
    >
      <rect x="206" y="8" rx="3" ry="3" width={random * 346} height="9" />
      <rect x="261" y="50" rx="3" ry="3" width={random * 213} height="20" />
      <rect x="5" y="118" rx="3" ry="3" width={random * 153} height="7" />
      <circle cx="34" cy="34" r="30" />
    </ContentLoader>
  );
};

export default WidgetLoader;
